<script>
    export let item;
</script>

<div id="type-col">{item.name != undefined ? item.name : ""} </div>

<style>
    #type-col {
        text-align: left;
    }
</style>
